import { createItemsStore } from '~/utils/pinia/light-items-store'

export const useNotificationsSubscriptionsListStore = createItemsStore(
  'notifications-subscriptions-list',
  {
    getItemsRequests: async () => {
      const { $sdk } = useNuxtApp()
      const {
        subscriptions: { idKey, getItems }
      } = await $sdk.module('notifications')

      return {
        idKey,
        getItems
      }
    }
  },
  context => {
    const providers = computed(() =>
      context.items.value.map(item => ({
        ...item,
        active: item.status ? item.status?.active : false
      }))
    )

    const fetchItems = (
      ...[requestQuery, pathOptions, requestOptions]: Parameters<
        (typeof context)['fetchItems']
      >
    ) => {
      return context.fetchItems(requestQuery, pathOptions, {
        resetBeforeFetch: false,
        ...(requestOptions ?? {})
      })
    }

    return {
      providers,
      fetchItems
    }
  }
)
